
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { palette, breakpoints } from '../../constants/styles';
import Title from '../shared/Title';
import Text from '../shared/Text';
import CTAButton from '../shared/CTAButton';

const CustomLink = styled.a`
  border-bottom: 2px dashed #022759;
  width: auto;
  &:hover {
    cursor: pointer;
  }
`;

const StyledInput = styled(Field)`
  font-family: 'Gotham SSm A', 'Gotham SSm B', sans-serif;
  font-size: 16px;
  background-color: transparent;
  font-weight: 400;
  line-height: normal;
  color: #282828;
  outline: none;
  box-shadow: 0px 4px 20px 0px transparent;
  transition: 0.3s background-color ease-in-out, 0.3s box-shadow ease-in-out, 0.1s padding ease-in-out;
  -webkit-appearance: none;
  border-top: none;
  border-right: none;
  border-left: none;
  width: 12em;
  text-align: left;
  outline: none;
  border-bottom: 2px dashed #022759;
  margin-right: 10px;
  border-radius: 2px;
  margin-bottom: 15px;

  ${breakpoints.mobileLandscape} {
    margin-bottom: 0px;
  }
`;

const StyledButton = styled.button`
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 8px;
  outline: none;
  box-shadow: 2px 2px 15px -3px rgba(0,0,0,0.25);
  width: 9em;
  color: #cecece;
  height: 3em;
  background-color: ${palette.preClick};

  &:hover {
    background-color: ${palette.primaryColor};
    cursor: pointer;
  } 
  
  margin: 0px 10px;
`;

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  ${breakpoints.mobileLandscape} {
    height: auto;
  }
`;

const StyledInnerForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${breakpoints.mobileLandscape} {
    flex-direction: row;
  }
`;


const StyledCustomInput = styled.div`
  display: flex;
  flex-direction: row;
`;

const ErrorMessage = styled.p`
  color: #2E8B57;
`;

const LoadingMessage = styled.p`
  color: #1f5dc2;
`;

const SuccessMessage = styled.p`
  color: #2E8B57;
`;

class GetPlan extends Component {
  state = {
    collapseOpen: true,
    success: false,
  }

  render() {
    const { collapseOpen, success } = this.state;
    const {
      onClick,
    } = this.props;

    return (
      <div>
        <Title level={3} align="center">No olvides guardar tu plan</Title>

        {/*
        {' '}
        <Title level={4} align="center">
          Haz clic
          {' '}
          <CustomLink onClick={() => { this.setState({ collapseOpen: !collapseOpen }); }}>aquí</CustomLink>
        </Title> */}
        {
          collapseOpen && (
            <div style={{ marginTop: '1em' }}>
              <StyledCustomInput>
                <Formik
                  initialValues={{
                    email: '',
                  }}
                  validationSchema={Yup.object().shape({
                    email: Yup.string()
                      .email('Debe ser un correo electrónico válido').required('Debe ser un correo electrónico válido'),
                  })}
                  onSubmit={(values) => {
                    onClick(values.email);
                    this.setState({ success: true });
                  }}
                >
                  {({ errors, touched }) => (
                    <StyledForm>
                      <StyledInnerForm>
                        <StyledInput name="email" placeHolder="tucorreo@ejemplo.com" />
                        <StyledButton type="submit">
                          <Text type="buttonText" color="white" medium>Guardar</Text>
                        </StyledButton>
                      </StyledInnerForm>
                      {errors.email && touched.email ? <Text type="errorMessage" style={{ alignSelf: 'flex-start', marginLeft: '5px' }} medium>{errors.email}</Text> : null}
                    </StyledForm>
                  )}
                </Formik>
              </StyledCustomInput>
              <div>
                {
                  success && (
                    <Text type="successMessage" color="white" medium>¡Listo! Enviamos tu plan a tu correo electrónico</Text>
                  )
                }
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

GetPlan.propTypes = {
  email: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  validationError: PropTypes.bool,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  success: PropTypes.bool,
};

GetPlan.defaultProps = {
  email: '',
  onChange: () => { },
  onClick: () => { },
  validationError: false,
  error: false,
  loading: false,
  success: false,
};


export default GetPlan;
